import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { ButtonRadio } from '@/components/base/ButtonRadio'

export function PrivateRegionViewSwitcher() {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation('privateRegion')

  // Derive active tab from URL path
  const pathSegments = location.pathname.split('/').filter(Boolean)
  const activeTab = pathSegments[pathSegments.length - 1] || 'dashboard'

  return (
    <ButtonRadio
      items={[
        { label: t('viewSwitcher.dashboard'), value: 'dashboard' },
        { label: t('viewSwitcher.computeNode'), value: 'compute' },
      ]}
      value={activeTab}
      onChange={(value) => navigate(`/private-region/${value}${location.search}`)}
    />
  )
}
